import React, { useContext, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { BsThreeDots } from "react-icons/bs";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { LiaUserPlusSolid } from "react-icons/lia";
import { PiNote } from "react-icons/pi";
import { TiDeleteOutline } from "react-icons/ti";
import { TbEdit } from "react-icons/tb";
import ShareuserIcons from "./ShareuserIcons";
import { newDateChanger } from "../Utils/CommonFunction";
import moment from "moment";

function CustomFolderList(props) {
  // console.log(props?.data);
  const MoreManu = ({ item }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () =>
      setDropdownOpen((prevState) => !prevState);
    return (
      <div className="moreMenu">
        <Dropdown
          isOpen={dropdownOpen}
          toggle={(e) => {
            toggleDropdown();
            e.stopPropagation();
          }}
        >
          <DropdownToggle caret>
            <BsThreeDots />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => props.detailstoggle(item)}>
              <MdOutlineRemoveRedEye /> View Details
            </DropdownItem>
            <DropdownItem onClick={() => props.sharetoggle(item)}>
              <LiaUserPlusSolid /> Share folder
            </DropdownItem>
            {/* <DropdownItem
              onClick={() => props.addNotetoggle(item?._id)}
            >
              <PiNote /> Add Description
            </DropdownItem> */}
            {/* <DropdownItem onClick={() => props.movetoggle(item?._id)}>
              <RiFolderTransferLine /> Move Password
            </DropdownItem> */}
            {/* <DropdownItem>
                      <RiFolderAddLine /> Move password in to a new
                      folder
                    </DropdownItem> */}
            <DropdownItem onClick={() => props.edittoggle(item)}>
              <TbEdit /> Edit Folder
            </DropdownItem>
            <DropdownItem onClick={() => props.confirmtoggle(item)}>
              <TiDeleteOutline /> Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <table className="table tableData" style={{ marginTop: 15 }}>
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#EFEFEF",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
              }}
            ></th>
            <th style={{ backgroundColor: "#EFEFEF" }}>
              {props.env_subfolder
                ? "Env/Subfolder Name"
                : "Folder/Project Name"}
            </th>
            {props.env_subfolder ? null : (
              <th style={{ backgroundColor: "#EFEFEF" }}>
                Total Environment
              </th>
            )}

            <th style={{ backgroundColor: "#EFEFEF" }}>
              Total Password
            </th>
            <th style={{ backgroundColor: "#EFEFEF" }}>Created On</th>
            <th style={{ backgroundColor: "#EFEFEF" }}>Created By</th>
            <th style={{ backgroundColor: "#EFEFEF" }}>
              Shared With
            </th>
            <th
              style={{
                backgroundColor: "#EFEFEF",
                borderTopRightRadius: "6px",
                borderBottomrightRadius: "6px",
              }}
            ></th>
          </tr>
        </thead>
        <tbody>
          {props?.data?.map((item, index) => {
            return (
              <tr
                key={index + "flist"}
                onClick={(e) => {
                  // if (!props.env_subfolder) {
                  props.onItem(item);
                  // }
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <td>
                  {/* <Input
                    type="checkbox"
                    style={{
                      width: "18px",
                      height: "18px",
                      border: "1px solid #131313",
                      cursor: "pointer",
                    }}
                    onChange={(e) => {
                      console.log("");
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  /> */}
                </td>

                <td>
                  <div
                    className="icon-plus-value"
                    style={{ width: "180px" }}
                  >
                    {/* <p className="row-value">Demo password</p> */}
                    <div
                      className="folder-name"
                      style={{ background: item?.color }}
                    >
                      {item?.name}
                    </div>
                  </div>
                </td>
                {props.env_subfolder ? null : (
                  <td>{item?.totalEnvs}</td>
                )}
                <td>{item?.totalPasswords}</td>
                <td>{moment(item?.createdAt).format("lll")}</td>
                <td>{item?.userName}</td>
                <td>
                  <ShareuserIcons
                    folderId={
                      props?.env_subfolder
                        ? item?.folderId
                        : item?.passwordFolderId
                        ? item?.passwordFolderId
                        : item?._id
                    }
                    envId={
                      item?.envId
                        ? item?.envId
                        : props?.env_subfolder
                        ? item?._id
                        : ""
                    }
                    env_subfolder={props?.env_subfolder}
                  />
                </td>
                <td>
                  {/* {props.env_subfolder ? (
                    <img
                      src={Eye}
                      alt="Eye view"
                      style={{
                        width: "18px",
                        height: "18px",
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    // <img
                    //   src={More}
                    //   alt="more option"
                    //   style={{
                    //     width: "18px",
                    //     height: "18px",
                    //     cursor: "pointer",
                    //   }}
                    // />
                    <MoreManu item={item} />
                  )} */}
                  {props?.hideMore ? null : <MoreManu item={item} />}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CustomFolderList;
